import PlansSectionController from '../common/section_controller'

// 実装は PC/SP 共通（common/section_controller.js）。
// デバイス固有の挙動は無いため、ここでは識別子の登録のためだけに継承する。
export default class extends PlansSectionController {}
